import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Container,
  Typography,
  Box,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useParams } from "react-router-dom";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Post_To_MongoDB } from "../../api/Post_To_MongoDB";
import { Registartion_Form_Post_Attendee_To_MongoDB_And_Email_Staff } from "./api/Registartion_Form_Post_Attendee_To_MongoDB_And_Email_Staff";
import { Get_All_From_MongoDB } from "../../api/Get_All_From_MongoDB";

const RegistrationForm = () => {
  const { id } = useParams();

  //redirect to
  window.location.href = `https://dukesinternalv3.onrender.com/Public/InvestINPublicRegistrationForm?source=VersionTwoRedirect&agentId=${id}`;


  return <>...</>
  const [EC, setEC] = useState({
    BasicInfo: { First_Name: "", Last_Name: "", Email: "" },
    MetaData: { Agency_id: "" },
  });

  useEffect(() => {
    if (id !== "Anonymous") {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        id,
        {
          "BasicInfo.First_Name": 1,
          "BasicInfo.Last_Name": 1,
          "BasicInfo.Email": 1,
          "MetaData.Agency_id": 1,
          EnrolmentFormSettings: 1,
          _id: 1,
        },
        setEC
      );
    }
  }, []);

  const [Agency, setAgency] = useState({});
  useEffect(() => {
    if (
      id !== "Anonymous" &&
      EC.MetaData &&
      EC.MetaData.Agency_id &&
      EC.MetaData.Agency_id.length > 0
    ) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          "BasicInfo.Name": 1,
        },
        setAgency
      );
    }
  }, [EC]);

  const [IP, setIP] = useState({});
  useEffect(() => {
    if (
      id !== "Anonymous" &&
      Agency.MetaData &&
      Agency.MetaData.IP_id &&
      Agency.MetaData.IP_id.length > 0
    ) {
      Get_One_Choose_Fields_From_MongoDB(
        "Staff",
        "Users",
        Agency.MetaData.IP_id,
        {
          Username: 1,
          _id: 1,
        },
        setIP
      );
    }
  }, [Agency]);

  let PageTitleTwo = "";
  if (id === "Anonymous") {
    PageTitleTwo = "";
  } else if (
    EC.EnrolmentFormSettings &&
    EC.EnrolmentFormSettings.Welcome_Text &&
    EC.EnrolmentFormSettings.Welcome_Text.length > 0
  ) {
    PageTitleTwo = EC.EnrolmentFormSettings.Welcome_Text;
  } else {
    PageTitleTwo =
      "In Partnership with " +
      EC?.BasicInfo?.First_Name +
      " " +
      EC?.BasicInfo?.Last_Name;
  }

  //Special question about who the invoice will be address too
  const [Invoice_Address_Who, setInvoice_Address_Who] = useState("");
  const handleInvoice_Address_WhoChange = (e) => {
    setInvoice_Address_Who(e.target.value);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    let data = {
      ...Attendee,
      Notes: [
        {
          DateTime: new Date().toISOString(),
          Note: Note + ", " + Invoice_Address_Who,
          Staff_ID: "Attendee",
        },
      ],
      Contacts: [
        { Person: "Attendee", Email: AttendeeEmail, Active: "Yes" },
        { Person: "Parent", Email: ParentEmail, Active: "Yes" },
      ],
    };

    let IP_Email = "";
    let WhichStaffShouldTheyEmail = "";
    let AllEmailsArray = [];
    if (id === "Anonymous") {
      WhichStaffShouldTheyEmail = "info@investin.org";
      AllEmailsArray = [
        AttendeeEmail,
        ParentEmail,
        "info@investin.org",
        "curtis@investin.org",
      ];
    } else {
      data = {
        ...data,
        IPInfo: { ...Attendee.IPInfo, EC_ID: EC._id },
      };
      IP_Email = IP?.Username;
      WhichStaffShouldTheyEmail = "international@investin.org";
      AllEmailsArray = [
        EC?.BasicInfo?.Email,
        IP?.Username,
        AttendeeEmail,
        ParentEmail,
        "curtis@investin.org",
        "rebecca@investin.org",
        "international@investin.org",
      ];
    }

    if (EC.EnrolmentFormSettings?.Gross_Or_Net === "Gross_Only") {
      setAttendee({
        ...Attendee,
        OrderInfo: { ...Attendee.OrderInfo, GrossOrNet: "Gross" },
      });
      data = {
        ...data,
        OrderInfo: { ...Attendee.OrderInfo, GrossOrNet: "Gross" },
      };
    }
    if (EC.EnrolmentFormSettings?.Gross_Or_Net === "Net_Only") {
      setAttendee({
        ...Attendee,
        OrderInfo: { ...Attendee.OrderInfo, GrossOrNet: "Net" },
      });
      data = {
        ...data,
        OrderInfo: { ...Attendee.OrderInfo, GrossOrNet: "Net" },
      };
    }

    setIsSubmitted(true);
    Registartion_Form_Post_Attendee_To_MongoDB_And_Email_Staff(
      data,
      "Registers_2025",
      "All",
      setIsSubmitting,
      AllEmailsArray,
      IP_Email,
      "InvestIN Registration Form Submission",
      WhichStaffShouldTheyEmail
    );
  };

  const [Attendee, setAttendee] = useState({
    //_id: "id",
    BasicInfo: {
      Created_At: new Date().toISOString(),
      First_Name: "",
      Last_Name: "",
      Gender: "",
      Nationality: "",
      DOB: "",
      uncleanSchool: "",
      School_id: "",
      ProgrammeTitle: "",
      ProgrammeDate: "",
      ProgrammeVarient: "",
      ProgrammeAge: "15-18",
    },
    OrderInfo: {
      OriginalOrderPlatform: "RegistrationForm",
      OriginalOrderNumber: "",
      LineItemPrice: "",
      LineItemDiscount: "",
      Deposit: "",
      Aiport_Price: "",
      Accom_Meals: "",
      DiscountCode: "",
      GrossOrNet: "Gross",
    },
    Payments: [],
    Contacts: [],
    Notes: [],
    MetaData: {
      Reserved: "Yes",
      Archived: "",
      CreatedBy: "RegistrationFormAnonymous",
      PrimaryStaff: "",
      Password: "p" + Math.floor(10000000 + Math.random() * 90000000),
    },
    IPInfo: {},
    VISA: {},
  });

  // Functions for handling changes in BasicInfo
  const handleBasicInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: { ...Attendee.BasicInfo, [e.target.name]: e.target.value },
    });
  };

  // Functions for handling changes in OrderInfo
  const handleOrderInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      OrderInfo: { ...Attendee.OrderInfo, [e.target.name]: e.target.value },
    });
  };

  // Functions for handling changes in IPInfo
  const handleIPInfoChange = (e) => {
    setAttendee({
      ...Attendee,
      IPInfo: { ...Attendee.IPInfo, [e.target.name]: e.target.value },
    });
  };

  const handleVISAChange = (e) => {
    setAttendee({
      ...Attendee,
      VISA: { ...Attendee.VISA, [e.target.name]: e.target.value },
    });
  };

  const [Note, setNote] = useState("");

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const [AttendeeEmail, setAttendeeEmail] = useState("");
  const handleAttendeeEmailChange = (e) => {
    setAttendeeEmail(e.target.value);
  };
  const [ParentEmail, setParentEmail] = useState("");
  const handleParentEmailChange = (e) => {
    setParentEmail(e.target.value);
  };

  //////Programme Choices

  const [ProgrammeType, setProgrammeType] = useState("SXP");
  const [Programme_Length, setProgramme_Length] = useState("");
  const [ProgrammeAccom, setProgrammeAccom] = useState("");
  const [ProgrammeAirportArrival, setProgrammeAirportArrival] = useState("");
  const [ProgrammeAirportDeparture, setProgrammeAirportDeparture] =
    useState("");

  // const handleProgrammeAgeChange = (e) => {
  //   setProgrammeType("SXP");
  //   setProgrammeAccom("");
  //   setProgrammeAirportArrival("");
  //   setProgrammeAirportDeparture("");
  //   setProgramme_Length("");
  //   setAttendee({
  //     ...Attendee,
  //     BasicInfo: {
  //       ...Attendee.BasicInfo,
  //       ["ProgrammeTitle"]: "",
  //       ["ProgrammeDate"]: "",
  //       ["ProgrammeVarient"]: "",
  //       ["ProgrammeAge"]: e.target.value,
  //     },
  //     OrderInfo: {
  //       ...Attendee.OrderInfo,
  //       ["ProgrammeAirportDeparture"]: "",
  //       ["ProgrammeAirportArrival"]: "",
  //     },
  //   });
  // };

  const handleTypeChange = (event) => {
    setProgrammeType(event.target.value);
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: "",
        ["ProgrammeDate"]: "",
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportDeparture"]: "",
        ["ProgrammeAirportArrival"]: "",
      },
    });
    setProgramme_Length("");
    setProgrammeAccom("");
    setProgrammeAirportArrival("");
    setProgrammeAirportDeparture("");
  };

  const handleProgrammeTitleChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeTitle"]: e.target.value,
        ["ProgrammeDate"]: "",
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportDeparture"]: "",
        ["ProgrammeAirportArrival"]: "",
      },
    });
    setProgramme_Length("");
    setProgrammeAccom("");
    setProgrammeAirportArrival("");
    setProgrammeAirportDeparture("");
  };

  const handleProgrammeDateChange = (e) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeDate"]: e.target.value,
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportDeparture"]: "",
        ["ProgrammeAirportArrival"]: "",
      },
    });
    setProgramme_Length("");
    setProgrammeAccom("");
    setProgrammeAirportArrival("");
    setProgrammeAirportDeparture("");
  };

  function handleProgramme_LengthChange(e) {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportDeparture"]: "",
        ["ProgrammeAirportArrival"]: "",
      },
    });
    setProgramme_Length(e.target.value);
    setProgrammeAccom("");
    setProgrammeAirportArrival("");
    setProgrammeAirportDeparture("");
  }

  const handleProgrammeAccomChange = (event) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeVarient"]: "",
      },
    });
    setProgrammeAccom(event.target.checked ? "Yes" : "");
  };

  const handleProgrammeAirportArrivalChange = (event) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportArrival"]: event.target.checked ? "Yes" : "",
      },
    });
    setProgrammeAirportArrival(event.target.checked ? "Yes" : "");
  };

  const handleProgrammeAirportDepartureChange = (event) => {
    setAttendee({
      ...Attendee,
      BasicInfo: {
        ...Attendee.BasicInfo,
        ["ProgrammeVarient"]: "",
      },
      OrderInfo: {
        ...Attendee.OrderInfo,
        ["ProgrammeAirportDeparture"]: event.target.checked ? "Yes" : "",
      },
    });
    setProgrammeAirportDeparture(event.target.checked ? "Yes" : "");
  };

  const isFormValid = () => {
    return (
      Attendee?.BasicInfo?.First_Name &&
      Attendee?.BasicInfo?.Last_Name &&
      Attendee?.BasicInfo?.Gender &&
      Attendee?.BasicInfo?.Nationality &&
      Attendee?.BasicInfo?.DOB &&
      Attendee?.BasicInfo?.uncleanSchool &&
      AttendeeEmail &&
      ParentEmail &&
      Attendee?.BasicInfo?.ProgrammeTitle &&
      Attendee?.BasicInfo?.ProgrammeDate &&
      Attendee?.BasicInfo?.ProgrammeVarient &&
      Attendee?.BasicInfo?.ProgrammeVarient !== "" &&
      Attendee?.BasicInfo?.ProgrammeAge &&
      Attendee?.OrderInfo?.GrossOrNet &&
      //(Attendee?.OrderInfo?.Deposit || ProgrammeType !== "SXP") &&
      Attendee?.IPInfo?.Consent_For_EC_To_See_Data
    );
  };

  const [ProgrammeData, setProgrammeData] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Lookups", "Programmes_2025", setProgrammeData);
  }, []);

  //Filter Array
  let ArrAllProgrammesFiltered = ProgrammeData;

  function isDateBefore7DaysAfter(dateString) {
    // Define the regular expression to match the date pattern
    const datePattern = /\((\d{1,2}(?:st|nd|rd|th)?\s+\w+\s+\d{4})\)/;

    // Apply the regular expression to extract the date
    const match = dateString.match(datePattern);

    // If a match is found, process the extracted date
    if (match && match[1]) {
      let extractedDate = match[1];

      // Remove the ordinal suffix (st, nd, rd, th) from the day
      extractedDate = extractedDate.replace(/(\d{1,2})(st|nd|rd|th)/, "$1");

      // Convert the extracted date to a Date object
      const dateObject = new Date(extractedDate);

      // Get today's date
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set the time to midnight to compare only the date part

      // Calculate the date that is 7 days after today
      const sevenDaysBeforeToday = new Date(today);
      sevenDaysBeforeToday.setDate(today.getDate() + 7);

      // Return true if the date is after 7 days after today, false otherwise
      return dateObject > sevenDaysBeforeToday;
    }

    // If no match is found, return false or an appropriate value
    return false;
  }

  //Filter weekend options if coming up
  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter(
    (Varient) => isDateBefore7DaysAfter(Varient.Dates) || Varient.Type === "SXP"
  );
  //Filter by Age
  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
    Varient.Age.includes(Attendee?.BasicInfo?.ProgrammeAge)
  );
  //Filter by Type
  ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
    Varient.Type.includes(ProgrammeType)
  );
  //Ok, we have dealt with the independant variables. First, get the Title by filtering out any closed bookings
  /////////////////////////////////////////Get Titles
  let ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered.filter(
    (Varient) => Varient.Closed !== "Yes"
  );
  //Filter by dates chosen
  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeDate"]) {
        return Varient.Dates === Attendee.BasicInfo["ProgrammeDate"];
      } else {
        return true;
      }
    }
  );

  //Just Get Title
  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.map(
    (Varient) => Varient.Title
  );
  //DeDpuplicate
  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.filter(
    (value, index, self) => self.indexOf(value) === index
  );
  //remove any titles that are called "TBC Young Summer Experience"
  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.filter(
    (value) => value !== "TBC Young Summer Experience"
  );

  ///////////////////////////////////////Now get the dates

  let ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered;
  //Filter by title chosen
  ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_Dates.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]) {
        return Varient.Title === Attendee.BasicInfo["ProgrammeTitle"];
      } else {
        return true;
      }
    }
  );

  // ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_Dates.filter(
  //   (value) => value !== "TBC"
  // );
  //get Open Dates
  let ArrAllProgrammesFiltered_Dates_Open =
    ArrAllProgrammesFiltered_Dates.filter(
      (Varient) => Varient.Closed !== "Yes"
    );

  ArrAllProgrammesFiltered_Dates_Open = ArrAllProgrammesFiltered_Dates_Open.map(
    (Varient) => Varient.Dates
  );
  ArrAllProgrammesFiltered_Dates_Open =
    ArrAllProgrammesFiltered_Dates_Open.filter(
      (value, index, self) => self.indexOf(value) === index
    );
  ArrAllProgrammesFiltered_Dates_Open =
    ArrAllProgrammesFiltered_Dates_Open.filter((value) => value !== "TBC");
  //get Closed Dates
  let ArrAllProgrammesFiltered_Dates_Closed =
    ArrAllProgrammesFiltered_Dates.filter(
      (Varient) => Varient.Closed === "Yes"
    );
  ArrAllProgrammesFiltered_Dates_Closed =
    ArrAllProgrammesFiltered_Dates_Closed.map((Varient) => Varient.Dates);
  ArrAllProgrammesFiltered_Dates_Closed =
    ArrAllProgrammesFiltered_Dates_Closed.filter(
      (value, index, self) => self.indexOf(value) === index
    );
  ArrAllProgrammesFiltered_Dates_Closed =
    ArrAllProgrammesFiltered_Dates_Closed.filter((value) => value !== "TBC");
  //Remove anything in the closed varients from the open varients
  ArrAllProgrammesFiltered_Dates_Closed =
    ArrAllProgrammesFiltered_Dates_Closed.filter(
      (value) => !ArrAllProgrammesFiltered_Dates_Open.includes(value)
    );

  //////////////////////////////////////  //Get Lengths
  //Filter out those closed
  let ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered.filter(
    (Varient) => Varient.Closed !== "Yes"
  );

  //Filter by title chosen
  ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered_Lengths.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]) {
        return Varient.Title === Attendee.BasicInfo["ProgrammeTitle"];
      } else {
        return true;
      }
    }
  );
  //Filter by date chosen
  ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered_Lengths.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeDate"]) {
        return Varient.Dates === Attendee.BasicInfo["ProgrammeDate"];
      } else {
        return true;
      }
    }
  );
  //Just get lengths
  ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered_Lengths.map(
    (Varient) => Varient.Length
  );
  //DeDuplicate
  ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered_Lengths.filter(
    (value, index, self) => self.indexOf(value) === index
  );
  //remove any lengths that are called "TBC"
  ArrAllProgrammesFiltered_Lengths = ArrAllProgrammesFiltered_Lengths.filter(
    (value) => value !== "TBC"
  );

  ///////////////////////////////////Now we have to look at varients

  let ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered;
  //Filter by Accom or NonAccom
  if (ProgrammeAccom === "Yes") {
    ArrAllProgrammesFiltered_Varients =
      ArrAllProgrammesFiltered_Varients.filter((Varient) =>
        Varient.Accom.includes("Yes")
      );
  } else {
    ArrAllProgrammesFiltered_Varients =
      ArrAllProgrammesFiltered_Varients.filter(
        (Varient) => !Varient.Accom.includes("Yes")
      );
  }
  //Filter by Air or NonAir
  if (
    ProgrammeAirportArrival === "Yes" ||
    ProgrammeAirportDeparture === "Yes"
  ) {
    ArrAllProgrammesFiltered_Varients =
      ArrAllProgrammesFiltered_Varients.filter((Varient) =>
        Varient.Airport.toLowerCase().includes("yes")
      );
  } else {
    ArrAllProgrammesFiltered_Varients =
      ArrAllProgrammesFiltered_Varients.filter(
        (Varient) => !Varient.Airport.toLowerCase().includes("yes")
      );
  }
  //Filter by title chosen
  ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered_Varients.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeTitle"]) {
        return Varient.Title === Attendee.BasicInfo["ProgrammeTitle"];
      } else {
        return true;
      }
    }
  );
  //Filter by date chosen
  ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered_Varients.filter(
    (Varient) => {
      if (Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeDate"]) {
        return Varient.Dates === Attendee.BasicInfo["ProgrammeDate"];
      } else {
        return true;
      }
    }
  );
  //Filter by programme length
  ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered_Varients.filter(
    (Varient) => {
      if (Programme_Length) {
        return Varient.Length === Programme_Length;
      } else {
        return true;
      }
    }
  );
  //get Open Varients
  let ArrAllProgrammesFiltered_Varients_Open =
    ArrAllProgrammesFiltered_Varients.filter(
      (Varient) => Varient.Closed !== "Yes"
    );
  ArrAllProgrammesFiltered_Varients_Open =
    ArrAllProgrammesFiltered_Varients_Open.map((Varient) => Varient.Varient);
  ArrAllProgrammesFiltered_Varients_Open =
    ArrAllProgrammesFiltered_Varients_Open.filter(
      (value, index, self) => self.indexOf(value) === index
    );
  //get Closed Varients
  let ArrAllProgrammesFiltered_Varients_Closed =
    ArrAllProgrammesFiltered_Varients.filter(
      (Varient) => Varient.Closed === "Yes"
    );
  ArrAllProgrammesFiltered_Varients_Closed =
    ArrAllProgrammesFiltered_Varients_Closed.map((Varient) => Varient.Varient);
  ArrAllProgrammesFiltered_Varients_Closed =
    ArrAllProgrammesFiltered_Varients_Closed.filter(
      (value, index, self) => self.indexOf(value) === index
    );
  //Remove anything in the closed varients from the open varients
  ArrAllProgrammesFiltered_Varients_Closed =
    ArrAllProgrammesFiltered_Varients_Closed.filter(
      (value) => !ArrAllProgrammesFiltered_Varients_Open.includes(value)
    );

  //////////////////////////////////////////

  let Total_Cost = 0;
  if (Programme_Length === "1 week") {
    Total_Cost += 2150;
  } else if (Programme_Length === "2 week") {
    Total_Cost += 3150;
  } else if (Programme_Length === "Premium") {
    Total_Cost += 4250;
  }
  //if ProgrammeVarient includes "UCAS" add 375 to cost
  if (Attendee?.BasicInfo?.ProgrammeVarient?.includes("UCAS")) {
    Total_Cost += 375;
  }

  if (Programme_Length === "1 week" && ProgrammeAccom === "Yes") {
    Total_Cost += 1400;
  } else if (
    Programme_Length === "2 week" &&
    ProgrammeAccom === "Yes" &&
    Attendee?.BasicInfo?.ProgrammeAge === "15-18"
  ) {
    Total_Cost += 3000;
  } else if (
    Programme_Length === "2 week" &&
    ProgrammeAccom === "Yes" &&
    Attendee?.BasicInfo?.ProgrammeAge === "18+"
  ) {
    Total_Cost += 1800;
  } else if (Programme_Length === "Premium" && ProgrammeAccom === "Yes") {
    Total_Cost += 3000;
  }
  if (ProgrammeAirportArrival === "Yes") {
    Total_Cost += 150;
  }
  if (ProgrammeAirportDeparture === "Yes") {
    Total_Cost += 150;
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
            alt="InvestIN Banner Logo"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            InvestIN Registration Form
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography
            variant="h5"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "grey.700" }}
            style={{ textAlign: "center" }}
          >
            {PageTitleTwo}
          </Typography>
        </Box>

        <hr
          style={{ backgroundColor: "grey", height: "2px", margin: "10px 0" }}
        />
        {isSubmitted ? (
          <>
            <Typography variant="h5" component="h1" gutterBottom>
              Thank you for Submitting the Form. A confirmation email will be
              sent to your provided email address. You may now close this tab,
              or return to the form to submit another registration. We will keep
              all the previous information you have entered in the form, so you
              can make any changes if needed.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => setIsSubmitted(false)}
            >
              Return to Form
            </Button>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5" component="h1" gutterBottom>
                    Basic Info
                  </Typography>
                  <TextField
                    key="First_Name"
                    name="First_Name"
                    label="Student First Name"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["First_Name"]
                        ? Attendee.BasicInfo["First_Name"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    key="Last_Name"
                    name="Last_Name"
                    label="Student Last Name"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["Last_Name"]
                        ? Attendee.BasicInfo["Last_Name"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    label="Student Gender"
                    name="Gender"
                    variant="outlined"
                    margin="normal"
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["Gender"]
                        ? Attendee.BasicInfo["Gender"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    select
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem key="M" value="M">
                      M
                    </MenuItem>{" "}
                    <MenuItem key="F" value="F">
                      F
                    </MenuItem>
                  </TextField>{" "}
                  <TextField
                    key="Nationality"
                    name="Nationality"
                    label="Student Nationality"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["Nationality"]
                        ? Attendee.BasicInfo["Nationality"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    key="DOB"
                    name="DOB"
                    label="Student DOB"
                    variant="outlined"
                    margin="normal"
                    type="date"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["DOB"]
                        ? Attendee.BasicInfo["DOB"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true, // This will keep the label above the input field
                    }}
                  />
                  <TextField
                    key="uncleanSchool"
                    name="uncleanSchool"
                    label="School of Student"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.BasicInfo && Attendee.BasicInfo["uncleanSchool"]
                        ? Attendee.BasicInfo["uncleanSchool"]
                        : ""
                    }
                    onChange={handleBasicInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    key="AttendeeEmail"
                    name="AttendeeEmail"
                    label="Email Address of the Student"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={AttendeeEmail}
                    onChange={handleAttendeeEmailChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    key="ParentEmail"
                    name="ParentEmail"
                    label="Email Address of the Parent"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={ParentEmail}
                    onChange={handleParentEmailChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <Typography variant="h5" component="h1" gutterBottom>
                    Programme Information
                  </Typography>
                  {/* {id !== "Anonymous" ? (
                    <TextField
                      key="ProgrammeAge"
                      name="ProgrammeAge"
                      label="Programme Age"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={
                        Attendee.BasicInfo && Attendee.BasicInfo["ProgrammeAge"]
                          ? Attendee.BasicInfo["ProgrammeAge"]
                          : ""
                      }
                      onChange={handleProgrammeAgeChange}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                        },
                      }}
                      select
                    >
                      <MenuItem key="15-18" value="15-18">
                        15-18
                      </MenuItem>
                      <MenuItem key="18+" value="18+">
                        18+
                      </MenuItem>
                    </TextField>
                  ) : (
                    <></>
                  )} */}
                  <TextField
                    key="ProgrammeType"
                    name="ProgrammeType"
                    label="Programme Type"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={ProgrammeType}
                    onChange={handleTypeChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    select
                  >
                    <MenuItem key="SXP" value="SXP">
                      Summer Experience
                    </MenuItem>
                    <MenuItem key="Weekend" value="Weekend">
                      Weekend
                    </MenuItem>
                  </TextField>
                  {ProgrammeType === "SXP" &&
                  Attendee?.BasicInfo?.ProgrammeAge === "15-18" ? (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/2025SXPTimeTable.png`}
                        alt="2025 SXP Time Table"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {ProgrammeType === "SXP" &&
                  Attendee?.BasicInfo?.ProgrammeAge === "18+" ? (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/2025AdultSXPTimeTable.png`}
                        alt="2025 Adult SXP Time Table"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <>
                    <TextField
                      key="ProgrammeTitle"
                      name="ProgrammeTitle"
                      label="Programme Title"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={
                        Attendee.BasicInfo &&
                        Attendee.BasicInfo["ProgrammeTitle"]
                          ? Attendee.BasicInfo["ProgrammeTitle"]
                          : ""
                      }
                      onChange={handleProgrammeTitleChange}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                        },
                      }}
                      select
                    >
                      <MenuItem key={""} value={""}>
                        Null
                      </MenuItem>
                      {ArrAllProgrammesFiltered_Titles.map((Title) => (
                        <MenuItem key={Title} value={Title}>
                          {Title}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      key="ProgrammeDate"
                      name="ProgrammeDate"
                      label="Programme Date"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={
                        Attendee.BasicInfo &&
                        Attendee.BasicInfo["ProgrammeDate"]
                          ? Attendee.BasicInfo["ProgrammeDate"]
                          : ""
                      }
                      onChange={handleProgrammeDateChange}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                        },
                      }}
                      select
                    >
                      {/* {ArrAllProgrammesFiltered_Dates.map((Date) => (
                        <MenuItem key={Date} value={Date}>
                          {Date}
                        </MenuItem>
                      ))} */}
                      <MenuItem key={""} value={""}>
                        Null
                      </MenuItem>
                      {ArrAllProgrammesFiltered_Dates_Open.map((Date) => (
                        <MenuItem key={Date} value={Date}>
                          {Date}
                        </MenuItem>
                      ))}
                      {ArrAllProgrammesFiltered_Dates_Closed.map((Date) => (
                        <MenuItem key={Date} value={Date} disabled={true}>
                          {Date} - FULL BOOKED
                        </MenuItem>
                      ))}
                    </TextField>
                    {ProgrammeType === "SXP" ? (
                      <>
                        <TextField
                          key="Programme_Length"
                          name="Programme_Length"
                          label="Programme Length"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          value={Programme_Length}
                          onChange={handleProgramme_LengthChange}
                          InputProps={{
                            style: {
                              backgroundColor: "white",
                            },
                          }}
                          select
                        >
                          <MenuItem key={""} value={""}>
                            Null
                          </MenuItem>
                          {ArrAllProgrammesFiltered_Lengths.map((Length) => (
                            <MenuItem key={Length} value={Length}>
                              {Length === "1 week"
                                ? "1 Week (+£2,150)"
                                : Length === "2 week"
                                ? "2 Weeks (+£3,150)"
                                : Length === "Premium"
                                ? "2 Weeks Premium (+£4,250)"
                                : ""}
                            </MenuItem>
                          ))}
                          {!ArrAllProgrammesFiltered_Lengths.includes(
                            "1 week"
                          ) ? (
                            <MenuItem
                              key={"1 Week"}
                              value={"1 Week"}
                              disabled={true}
                            >
                              1 Week (+£2,150) - FULLY BOOKED"
                            </MenuItem>
                          ) : !ArrAllProgrammesFiltered_Lengths.includes(
                              "2 week"
                            ) ? (
                            <MenuItem
                              key={"2 Week"}
                              value={"2 Week"}
                              disabled={true}
                            >
                              2 Week (+£3,150) - FULLY BOOKED"
                            </MenuItem>
                          ) : !ArrAllProgrammesFiltered_Lengths.includes(
                              "Premium"
                            ) ? (
                            <MenuItem
                              key={"Premium"}
                              value={"Premium"}
                              disabled={true}
                            >
                              Premium (+£4,250) - FULLY BOOKED"
                            </MenuItem>
                          ) : (
                            <></>
                          )}
                        </TextField>
                        <label>
                          <input
                            type="checkbox"
                            checked={ProgrammeAccom === "Yes"}
                            onChange={handleProgrammeAccomChange}
                          />
                          Accomodation, Meals and Guardianship (
                          {Programme_Length === "1 week"
                            ? "+£1,400"
                            : Programme_Length === "2 week" &&
                              Attendee?.BasicInfo?.ProgrammeAge === "15-18"
                            ? "+£3,000"
                            : Programme_Length === "2 week" &&
                              Attendee?.BasicInfo?.ProgrammeAge === "18+"
                            ? "+£1,800"
                            : Programme_Length === "Premium"
                            ? "+£3,000"
                            : "Price Varies, Please Choose Programme Length Above"}
                          )
                        </label>
                        <br></br>
                        <label>
                          <input
                            type="checkbox"
                            checked={ProgrammeAirportArrival === "Yes"}
                            onChange={handleProgrammeAirportArrivalChange}
                          />
                          Heathrow Airport Pick Up (+£150)
                        </label>
                        <br></br>
                        <label>
                          <input
                            type="checkbox"
                            checked={ProgrammeAirportDeparture === "Yes"}
                            onChange={handleProgrammeAirportDepartureChange}
                          />
                          Heathrow Airport Drop Off (+£150)
                        </label>
                      </>
                    ) : (
                      <></>
                    )}
                    <br></br>
                    <br></br>

                    {Programme_Length === "2 week" ? (
                      <Typography variant="h7" component="h7" gutterBottom>
                        2 Week Premium Programmes include the Official Work
                        Experience Qualification that gives you UCAS points. As
                        you have selected 2 Weeks, you will have the ability to
                        add this on for an additonal £375 in the below field.
                      </Typography>
                    ) : (
                      <></>
                    )}
                    <TextField
                      key="ProgrammeVarient"
                      name="ProgrammeVarient"
                      label="Programme Varient"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={
                        Attendee.BasicInfo &&
                        Attendee.BasicInfo["ProgrammeVarient"]
                          ? Attendee.BasicInfo["ProgrammeVarient"]
                          : ""
                      }
                      onChange={handleBasicInfoChange}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                        },
                      }}
                      select
                    >
                      <MenuItem key={""} value={""}>
                        Null
                      </MenuItem>
                      {/* {ArrAllProgrammesFiltered_Varients.map((Varient) => (
                        <MenuItem key={Varient} value={Varient}>
                          {Varient}
                        </MenuItem>
                      ))} */}
                      {ArrAllProgrammesFiltered_Varients_Open.map((Varient) => (
                        <MenuItem key={Varient} value={Varient}>
                          {Varient}
                        </MenuItem>
                      ))}
                      {ArrAllProgrammesFiltered_Varients_Closed.map(
                        (Varient) => (
                          <MenuItem
                            key={Varient}
                            value={Varient}
                            disabled={true}
                          >
                            {Varient} - FULL BOOKED
                          </MenuItem>
                        )
                      )}
                    </TextField>

                    {Total_Cost ? (
                      <>
                        <Typography
                          variant="h6"
                          component="h6"
                          gutterBottom
                          style={{ fontWeight: "bold", fontStyle: "italic" }}
                        >
                          Total Cost: £{Total_Cost}
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                  <Typography variant="h5" component="h1" gutterBottom>
                    VISA Information{" "}
                  </Typography>
                  <TextField
                    label="Do you require a VISA support letter"
                    name="Do_you_require_a_VISA_support_letter"
                    variant="outlined"
                    margin="normal"
                    value={
                      Attendee.VISA &&
                      Attendee.VISA["Do_you_require_a_VISA_support_letter"]
                        ? Attendee.VISA["Do_you_require_a_VISA_support_letter"]
                        : ""
                    }
                    onChange={handleVISAChange}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    select
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem key="Yes" value="Yes">
                      Yes
                    </MenuItem>{" "}
                    <MenuItem key="No" value="No">
                      No
                    </MenuItem>
                  </TextField>
                  {Attendee.VISA &&
                  Attendee.VISA["Do_you_require_a_VISA_support_letter"] ===
                    "Yes" ? (
                    <>
                      <TextField
                        key="Passport_Name"
                        name="Passport_Name"
                        label="Name as on Passport"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.VISA && Attendee.VISA["Passport_Name"]
                            ? Attendee.VISA["Passport_Name"]
                            : ""
                        }
                        onChange={handleVISAChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="Passport_Number"
                        name="Passport_Number"
                        label="Passport Number"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.VISA && Attendee.VISA["Passport_Number"]
                            ? Attendee.VISA["Passport_Number"]
                            : ""
                        }
                        onChange={handleVISAChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="Passport_DOB"
                        name="Passport_DOB"
                        label="Date of Birth as on Passport"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.VISA && Attendee.VISA["Passport_DOB"]
                            ? Attendee.VISA["Passport_DOB"]
                            : ""
                        }
                        onChange={handleVISAChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="Passport_Nationality"
                        name="Passport_Nationality"
                        label="Nationality as on Passport"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.VISA && Attendee.VISA["Passport_Nationality"]
                            ? Attendee.VISA["Passport_Nationality"]
                            : ""
                        }
                        onChange={handleVISAChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        label="Has the student ever been refused a VISA for any county including the UK"
                        name="Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                        variant="outlined"
                        margin="normal"
                        value={
                          Attendee.VISA &&
                          Attendee.VISA[
                            "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                          ]
                            ? Attendee.VISA[
                                "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                              ]
                            : ""
                        }
                        onChange={handleVISAChange}
                        fullWidth
                        sx={{ marginBottom: "10px" }}
                        select
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <MenuItem key="Yes" value="Yes">
                          Yes
                        </MenuItem>{" "}
                        <MenuItem key="No" value="No">
                          No
                        </MenuItem>
                      </TextField>
                      {Attendee.VISA &&
                      Attendee.VISA[
                        "Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK"
                      ] === "Yes" ? (
                        <>
                          <TextField
                            key="Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                            name="Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                            label="Which country or countries has the VISA been rejected from previously"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            value={
                              Attendee.VISA &&
                              Attendee.VISA[
                                "Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                              ]
                                ? Attendee.VISA[
                                    "Which_country_or_countries_has_the_VISA_been_rejected_from_previously"
                                  ]
                                : ""
                            }
                            onChange={handleVISAChange}
                            InputProps={{
                              style: {
                                backgroundColor: "white",
                              },
                            }}
                          />
                          <TextField
                            key="When_was_the_last_time_the_students_VISA_was_rejected"
                            name="When_was_the_last_time_the_students_VISA_was_rejected"
                            label="When was the last time the students VISA was rejected"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            value={
                              Attendee.VISA &&
                              Attendee.VISA[
                                "When_was_the_last_time_the_students_VISA_was_rejected"
                              ]
                                ? Attendee.VISA[
                                    "When_was_the_last_time_the_students_VISA_was_rejected"
                                  ]
                                : ""
                            }
                            onChange={handleVISAChange}
                            InputProps={{
                              style: {
                                backgroundColor: "white",
                              },
                            }}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <Typography variant="h5" component="h1" gutterBottom>
                    Invoice Information
                  </Typography>
                  {IP.Username === "shu@investin.org" ||
                  EC.BasicInfo.Email === "shu@investin.org" ||
                  //Temp for Richard EC called Omar
                  EC._id === "677270da09258353f3ca6948" ||
                  EC.EnrolmentFormSettings?.Gross_Or_Net === "Gross_Only" ||
                  EC.EnrolmentFormSettings?.Gross_Or_Net === "Net_Only" ? (
                    <></>
                  ) : (
                    <>
                      <Typography variant="h7" component="h7" gutterBottom>
                        Standard invoices are gross. Should you wish to change
                        to Net, you may do so. If you are unsure of the
                        difference, then you will likely want to use Gross
                      </Typography>
                      <TextField
                        label="Gross Or Net"
                        name="GrossOrNet"
                        variant="outlined"
                        margin="normal"
                        value={
                          Attendee.OrderInfo && Attendee.OrderInfo["GrossOrNet"]
                            ? Attendee.OrderInfo["GrossOrNet"]
                            : ""
                        }
                        onChange={handleOrderInfoChange}
                        fullWidth
                        sx={{ marginBottom: "10px" }}
                        select
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <MenuItem key="Gross" value="Gross">
                          Gross
                        </MenuItem>{" "}
                        <MenuItem key="Net" value="Net">
                          Net
                        </MenuItem>
                      </TextField>
                    </>
                  )}
                  {/* {ProgrammeType === "SXP" ? (
                    <>
                      <Typography variant="h7" component="h7" gutterBottom>
                        How would you like to make the payment? Option (1) Make
                        Deposit (£950) first (2) Make full amount payment
                      </Typography>
                      <TextField
                        label="Options"
                        name="Deposit"
                        variant="outlined"
                        margin="normal"
                        value={
                          Attendee.OrderInfo && Attendee.OrderInfo["Deposit"]
                            ? Attendee.OrderInfo["Deposit"]
                            : ""
                        }
                        onChange={handleOrderInfoChange}
                        fullWidth
                        sx={{ marginBottom: "10px" }}
                        select
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <MenuItem key="true" value="true">
                          (1) Make Deposit (£950) first
                        </MenuItem>
                        <MenuItem key="false" value="false">
                          (2) Make full amount payment
                        </MenuItem>{" "}
                      </TextField>
                    </>
                  ) : (
                    <></>
                  )} */}
                  <Typography variant="h7" component="h7" gutterBottom>
                    Please provide Discount Code
                  </Typography>
                  <TextField
                    key="DiscountCode"
                    name="DiscountCode"
                    label="Discount Code (Optional)"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={
                      Attendee.OrderInfo && Attendee.OrderInfo["DiscountCode"]
                        ? Attendee.OrderInfo["DiscountCode"]
                        : ""
                    }
                    onChange={handleOrderInfoChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  {/* Special Question for EC about invoice payment */}
                  {EC &&
                  EC.BasicInfo &&
                  EC.BasicInfo.Email &&
                  EC.BasicInfo.Email !== "" ? (
                    <>
                      <Typography variant="h7" component="h7" gutterBottom>
                        Who would you like your invoice addressed and sent to?
                      </Typography>
                      <TextField
                        label="Who should we address the invoice to?"
                        name="Invoice_Address_Who"
                        variant="outlined"
                        margin="normal"
                        value={Invoice_Address_Who}
                        onChange={handleInvoice_Address_WhoChange}
                        fullWidth
                        sx={{ marginBottom: "10px" }}
                        select
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <MenuItem
                          key="Student"
                          value="Invoice being Addressed to Student and sent to
                          Parents & Students + BCC EC onto the email"
                        >
                          Invoice being Addressed to Student and sent to Parents
                          & Students + BCC Educational Consultant onto the email
                        </MenuItem>
                        <MenuItem
                          key="EC"
                          value="Invoice being Addressed to EC and sent to EC"
                        >
                          Invoice being Addressed to Educational Consultant and
                          sent to Educational Consultant
                        </MenuItem>
                      </TextField>
                    </>
                  ) : (
                    <></>
                  )}
                  {/* Special IP Form Questions */}
                  {EC.BasicInfo?.Email.includes("@investin.org") ? (
                    <>
                      <Typography variant="h5" component="h1" gutterBottom>
                        Agency Details
                      </Typography>
                      <TextField
                        key="uncleanInfo"
                        name="uncleanInfo"
                        placeholder="Please state: (1) Agency Name (2) Education Consultant Full Name (3) Education Consultant Mobile (4) Education Consultant Email"
                        margin="normal"
                        fullWidth
                        multiline
                        rows={3}
                        value={
                          Attendee.IPInfo && Attendee.IPInfo["uncleanInfo"]
                            ? Attendee.IPInfo["uncleanInfo"]
                            : ""
                        }
                        onChange={handleIPInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />

                      <TextField
                        key="uncleanCountry"
                        name="uncleanCountry"
                        label="Agency's Country"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.IPInfo && Attendee.IPInfo["uncleanCountry"]
                            ? Attendee.IPInfo["uncleanCountry"]
                            : ""
                        }
                        onChange={handleIPInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                      <TextField
                        key="uncleanCity"
                        name="uncleanCity"
                        label="Agency's Office City"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        value={
                          Attendee.IPInfo && Attendee.IPInfo["uncleanCity"]
                            ? Attendee.IPInfo["uncleanCity"]
                            : ""
                        }
                        onChange={handleIPInfoChange}
                        InputProps={{
                          style: {
                            backgroundColor: "white",
                          },
                        }}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  <Typography variant="h5" component="h1" gutterBottom>
                    Is there anything else we should know? Our team will review
                    any note added below.
                  </Typography>
                  <TextField
                    key="Note"
                    name="Note"
                    label="Note"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    value={Note}
                    onChange={handleNoteChange}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                    multiline
                    rows={2}
                  />{" "}
                  <br></br>
                  <Typography variant="h5" component="h1" gutterBottom>
                    Please give consent so that the Educational Consultant who
                    refered you is able to access your application, personal
                    information and all forms we request of you so they can
                    assist in your booking
                  </Typography>
                  <TextField
                    label="Consent For Application Support"
                    name="Consent_For_EC_To_See_Data"
                    variant="outlined"
                    margin="normal"
                    value={
                      Attendee.IPInfo &&
                      Attendee.IPInfo["Consent_For_EC_To_See_Data"]
                        ? Attendee.IPInfo["Consent_For_EC_To_See_Data"]
                        : ""
                    }
                    onChange={handleIPInfoChange}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    select
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem key="" value=""></MenuItem>{" "}
                    <MenuItem key="Yes" value="Yes">
                      Yes
                    </MenuItem>{" "}
                    <MenuItem key="No" value="No">
                      No
                    </MenuItem>
                  </TextField>
                  <br></br> <br></br> <br></br>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleSubmit(e)}
                    disabled={isSubmitting || !isFormValid()}
                  >
                    {isFormValid ? (
                      <>Please Compelte All Fields To Submit</>
                    ) : isSubmitting ? (
                      "Submitting..."
                    ) : (
                      "Submit"
                    )}
                  </Button>
                  <br></br>
                  <br></br>
                  <br></br>
                  <br></br>
                </Grid>
              </Grid>
            </form>
          </>
        )}
      </Container>
    </div>
  );
};

export default RegistrationForm;
